import mapboxgl from 'mapbox-gl';

export const setupMapEventHandlers = (
  map: mapboxgl.Map,
  onUserInteraction: (isInteracting: boolean) => void
) => {
  map.on('mousedown', () => onUserInteraction(true));
  map.on('dragstart', () => onUserInteraction(true));
  map.on('mouseup', () => onUserInteraction(false));
  map.on('touchend', () => onUserInteraction(false));

  return () => {
    map.off('mousedown', () => onUserInteraction(true));
    map.off('dragstart', () => onUserInteraction(true));
    map.off('mouseup', () => onUserInteraction(false));
    map.off('touchend', () => onUserInteraction(false));
  };
};

export const setupMapEffects = (map: mapboxgl.Map) => {
  map.on('style.load', () => {
    map.setFog({
      'color': 'rgb(255, 255, 255)',
      'high-color': 'rgb(200, 200, 225)',
      'horizon-blend': 0.2,
      'space-color': 'rgb(100, 100, 150)',
      'star-intensity': 0.6
    });
  });
};